/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Calendar_Members_NInputs */

const cs_calendar_members_n = /** @type {(inputs: Calendar_Members_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} vybraných`)
};

const en_calendar_members_n = /** @type {(inputs: Calendar_Members_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} selected`)
};

/**
* | output |
* | --- |
* | "{count} selected" |
*
* @param {Calendar_Members_NInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const calendar_members_n = /** @type {((inputs: Calendar_Members_NInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Members_NInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calendar_members_n(inputs)
	return cs_calendar_members_n(inputs)
});